import React from 'react';
import PropTypes from 'prop-types';

import { InputDate } from '../../InputDate';

export const DateIntervalPoint = ({ config }) => {
    const periodConfig = { ...config };
    const [date, setDate] = React.useState(periodConfig.defaultValue);

    const isValid = periodConfig.validator(date);
    periodConfig.setDateIsValid(isValid);
    const hasError = isValid === false;

    return (
        <InputDate
            icon={periodConfig.icon}
            label={periodConfig.label}
            defaultValue={periodConfig.parseDateForDisplay(periodConfig.defaultValue)}
            placeholder={periodConfig.placeholder}
            data-cy={periodConfig.testsId}
            error={hasError}
            message={hasError ? periodConfig.errorFeedback : ''}
            onChange={evt => {
                setDate(evt);
                periodConfig.onChange(evt);
            }}
        />
    );
};

DateIntervalPoint.propTypes = {
    config: PropTypes.shape({
        testsId: PropTypes.string,
        icon: PropTypes.bool,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        defaultValue: PropTypes.shape({}).isRequired,
        onChange: PropTypes.func.isRequired,
        parseDateForDisplay: PropTypes.func.isRequired,
        validator: PropTypes.func,
        setDateIsValid: PropTypes.func,
        errorFeedback: PropTypes.string,
    }),
};

DateIntervalPoint.defaultProps = {
    config: PropTypes.shape({
        testsId: '',
        icon: false,
        label: '',
        placeholder: 'DD/MM/YYYY',
        validator: () => {},
        setDateIsValid: () => {},
        errorFeedback: '',
    }),
};

export default DateIntervalPoint;
